module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/ornament-left.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/ornament-left.png
// module id = 484
// module chunks = 0